/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Portals_Xml_GroupInputs */

const cs_listing_portals_xml_group = /** @type {(inputs: Listing_Portals_Xml_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML portály (sdílený feed)`)
};

const en_listing_portals_xml_group = /** @type {(inputs: Listing_Portals_Xml_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`XML portals (shared feed)`)
};

/**
* | output |
* | --- |
* | "XML portals (shared feed)" |
*
* @param {Listing_Portals_Xml_GroupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const listing_portals_xml_group = /** @type {((inputs?: Listing_Portals_Xml_GroupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Portals_Xml_GroupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_portals_xml_group(inputs)
	return cs_listing_portals_xml_group(inputs)
});